import React from "react";
import { connect } from "react-redux";
import Scroll from "react-scroll";
import { updateMakeAClaimProperties, reset } from "../../actions/makeAClaim/MakeAClaimActions";
import Contentify from "../../content/Contentify";
import LabelWithTooltip from "../shared/label/LabelWithTooltip";
import Store from "./../../content/Store";
import ChooseButton from "./../shared/ChooseButton";
import AreYouThePatient from "./AreYouThePatient";
import {
  MUSCLES_BONES_JOINTS_CONDITION,
  OTHER_CONDITION
} from "./Constants";
import IsNewClaimForCondition from "./IsNewClaimForCondition";

export const QueryForHBS = ({
  content,
  authoriseTreatmentCondition,
  updateMakeAClaimProperties,
  isThePatient,
  isLargeCorporate
}) => (
  <React.Fragment>

    <div className="hbsTop">
      <AreYouThePatient />
    </div>

    {isThePatient && (
      <div className="hbsTop">
        <LabelWithTooltip label={content.label} />
        <div></div>
        <ChooseButton
          horizontal
          icon={content.option1IconClass}
          title={content.option1Label}
          description={isLargeCorporate ? content.option1ContentLargeCorp : content.option1Content}
          selected={authoriseTreatmentCondition === MUSCLES_BONES_JOINTS_CONDITION}
          onClick={() => {
            authoriseTreatmentCondition = MUSCLES_BONES_JOINTS_CONDITION;
            updateMakeAClaimProperties({
              authoriseTreatmentCondition: MUSCLES_BONES_JOINTS_CONDITION
            });
            scrollToName();
          }}
        />
        <ChooseButton
          horizontal
          icon={content.option2IconClass}
          title={content.option2Label}
          description={content.option2Content}
          selected={authoriseTreatmentCondition === OTHER_CONDITION}
          onClick={() => {
            updateMakeAClaimProperties({
              authoriseTreatmentCondition: OTHER_CONDITION
            });
            scrollToName();
          }}
        />
      </div>
    )}

    {/* removing  ques 1 for muscle bone*/}
    {authoriseTreatmentCondition === OTHER_CONDITION && (
      <div className="mt-5">
        <IsNewClaimForCondition />
      </div>
    )}

  </React.Fragment>
);

function scrollToName() {
  Scroll.scroller.scrollTo(MUSCLES_BONES_JOINTS_CONDITION, {
    duration: 750,
    smooth: true
  });
}

QueryForHBS.content = Store.QueryForHBS;

export const mapStateToQueryForHBS = ({ makeAClaimReducer, policyReducer }) => ({
  authoriseTreatmentCondition: makeAClaimReducer.authoriseTreatmentCondition,
  isNewClaim: makeAClaimReducer.isNewClaim,
  isThePatient: makeAClaimReducer.isThePatient,
  isLargeCorporate: policyReducer.selectedPolicy &&
    policyReducer.selectedPolicy.IsLargeCorporate,
});

export default connect(mapStateToQueryForHBS, {
  updateMakeAClaimProperties,
  reset
})(Contentify(QueryForHBS));


